import { Controller } from "stimulus";
export default class extends Controller {
  static targets = [
    "amenities",
    "breakdown",
    "container",
    "togglable",
    "guestsCount",
    "childrenCount",
    "adultsCount",
    "card",
    "modal",
    "summaryModal"
  ];

  connect() {
    this.updateGuests();
    window.addEventListener('edit-guests-modal:guestsSaved', this.reloadSummary.bind(this))
  }

  updateGuests() {
    const is_insurance = this.element.closest('.content').classList.contains('insurance')
    this.cardTargets.forEach(card => {
      const children = this.childrenCountTargets.find(target =>
        card.contains(target)
      );
      const adults = this.adultsCountTargets.find(target =>
        card.contains(target)
      );

      const total = is_insurance ? parseFloat(card.dataset.totalInsurance) : parseFloat(card.dataset.total);
      const occupants = adults.value + children.value
      card.querySelector('.price-per-guest').textContent = `${total / occupants} / night`

      const guests = this.guestsCountTargets.filter(target =>
        card.contains(target)
      );

      guests.forEach(element => {
        element.textContent = `${adults.value} Adults, ${children.value} Children`;
      });
    });
  }

  showModal(event) {
    const modalEditButton = event.currentTarget;

    let currentModal = null;
    this.modalTargets.every(modal => {
      let currentCard = this.cardTargets.find(target =>
        target.contains(modalEditButton)
      );

      currentModal = this.modalTargets.find(target =>
        currentCard.contains(target)
      );

      return !currentModal;
    });

    MicroModal.show(currentModal.getAttribute("id"));
  }

  updateGuestsAndSave(event) {
    const modalSaveButton = event.currentTarget;

    this.updateGuests();

    let currentModal = null;
    this.modalTargets.every(modal => {
      currentModal = this.modalTargets.find(target =>
        target.contains(modalSaveButton)
      );
      return !currentModal;
    });

    if (currentModal) {
      MicroModal.close(currentModal.getAttribute("id"));
    } else {
      console.error("Modal not found");
    }
  }

  showBreakdown(event) {
    const button = event.currentTarget;
    const container = this.containerTargets.find(target =>
      target.contains(button)
    );
    const togglableElements = this.togglableTargets.filter(target =>
      container.contains(target)
    );

    togglableElements.forEach(togglable => {
      togglable.classList.toggle("active");
    });
  }
}
